import type { Trigger } from './types';

export const timeOnPageOver: Trigger = (
  triggerName = 'timeOnPageOver',
  duration
) => {
  const durationNumber = parseFloat(String(duration));

  if (Number.isNaN(durationNumber)) {
    throw new Error(
      `Cannot cast argument "duration" value type of "${typeof duration}" to a number`
    );
  }

  return (activate) => {
    const startTime = Date.now();
    const interval: NodeJS.Timeout = setInterval(() => {
      const timeIsOver = (Date.now() - startTime) / 1000 > durationNumber;

      if (timeIsOver) {
        if (interval) clearInterval(interval);

        activate(triggerName);
      }
    }, 100);

    return () => {
      if (interval) clearInterval(interval);
    };
  };
};
